import React from 'react';
import PropTypes from 'prop-types';
import { ButtonLoader } from 'app/components';
import './style';

const Button = (props) => {
  const {
    children,
    iconLeft,
    iconRight,
    rounded,
    type,
    size,
    disabled,
    className,
    loading,
    loadingText,
    ...attr
  } = props;

  return (
    <button
      className={`button text-cta flex items-center justify-center gap-2.5`
        + `${rounded ? ' rounded' : ''} ${type} ${size} ${disabled || loading ? ' disabled' : ''} ${className}`}
      disabled={disabled || loading}
      {...attr}
    >
      {loading ? (
        <ButtonLoader 
          size={size === 'small' ? 16 : 20} 
          text={loadingText}
          showText={!!loadingText}
        />
      ) : (
        <>
          {iconLeft && (
            <div className="icon-left">{iconLeft}</div>
          )}
          {children}
          {iconRight && (
            <div className="icon-right">{iconRight}</div>
          )}
        </>
      )}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  iconLeft: PropTypes.node,
  iconRight: PropTypes.node,
  rounded: PropTypes.bool,
  type: PropTypes.oneOf(['primary', 'primary-black', 'secondary', 'tertiary', 'tertiary-text', 'tertiary-text-underlined']),
  size: PropTypes.oneOf(['regular', 'small']),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  loadingText: PropTypes.string,
  className: PropTypes.string,
};

Button.defaultProps = {
  children: null,
  iconLeft: null,
  iconRight: null,
  rounded: false,
  type: 'primary',
  size: 'regular',
  disabled: false,
  loading: false,
  loadingText: '',
  className: '',
};

export default Button;
